"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReadingPromptWithDataLegacy = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var react_1 = __importDefault(require("react"));
var legacy_queries_1 = require("../../../../../shared/api/legacy-queries");
var utils_1 = require("../../../utils");
var ReadingPromptLegacy_1 = require("./ReadingPromptLegacy");
var getLastActual = function (meterReadingData, supplyInfo, fuel) {
    var isTraditional = supplyInfo[fuel] && supplyInfo[fuel].type === 'traditional'; // eslint-disable-line @typescript-eslint/no-non-null-assertion
    var reads = meterReadingData && meterReadingData[fuel];
    return isTraditional && reads ? (0, utils_1.getLatestActualRead)(reads) : undefined;
};
var Data = function (_a) {
    var _b = __read(_a.data, 1), fetchedMeterReadsData = _b[0], _c = _a.props, fuel = _c.fuel, supplyInfo = _c.supplyInfo;
    if (!(0, utils_1.hasTradMeter)(supplyInfo)) {
        return null;
    }
    if (fetchedMeterReadsData) {
        return (react_1.default.createElement(ReadingPromptLegacy_1.ReadingPromptLegacy, { lastActualElecRead: getLastActual(fetchedMeterReadsData, supplyInfo, 'electricity'), lastActualGasRead: getLastActual(fetchedMeterReadsData, supplyInfo, 'gas'), fuel: fuel }));
    }
    return null;
};
var ReadingPromptWithDataLegacy = function (_a) {
    var accountId = _a.accountId, fuel = _a.fuel, supplyInfo = _a.supplyInfo;
    var meterReadingsQueryResult = (0, legacy_queries_1.useMeterReadingsLegacyQuery)(accountId);
    return (react_1.default.createElement(ui_tools_1.QueryResultRenderer, { forwardProps: { fuel: fuel, supplyInfo: supplyInfo }, queryResults: [meterReadingsQueryResult], NoData: function () { return null; }, Error: function () { return null; }, Data: Data }));
};
exports.ReadingPromptWithDataLegacy = ReadingPromptWithDataLegacy;
